// MechaniCar stylish wordmark
// Capital M and C → oversized, italic, red drop-cap style (motion + emphasis)
// "echani" and "ar"  → bold, tight tracking, white
export function BrandWord({ className = "" }) {
  return (
    <span className={`inline-flex items-baseline font-heading ${className}`}>
      <span className="text-[#FF3B30] text-[1.35em] italic font-black leading-[0.85] tracking-tighter -mr-[0.04em] drop-shadow-[0_0_0.4em_rgba(255,59,48,0.35)]">
        M
      </span>
      <span className="font-bold tracking-tight">echani</span>
      <span className="text-[#FF3B30] text-[1.35em] italic font-black leading-[0.85] tracking-tighter -ml-[0.02em] -mr-[0.04em] drop-shadow-[0_0_0.4em_rgba(255,59,48,0.35)]">
        C
      </span>
      <span className="font-bold tracking-tight">ar</span>
    </span>
  );
}
